import { Checkbox } from '@mantine/core'

export const CheckboxThemeKobo = Checkbox.extend({
  styles: {
    label: { paddingInlineStart: '8px' },
  },
})
